/*
 * PartnersContent.jsx
 * Created by Destin Frasier on 10/23/17
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const propTypes = {
    linkUrl: PropTypes.string,
    icon: PropTypes.element,
    title: PropTypes.string
};

export default class PartnersContent extends React.Component {
    render() {
        return (
            <li>
                <Link
                    to={this.props.linkUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={this.props.title}>
                    {this.props.icon}
                </Link>
            </li>
        );
    }
}

PartnersContent.propTypes = propTypes;
